import { useMemo, useState } from "react"

import { THome } from "src/data/homes/types/homeTypes"
import { useOrganization } from "src/data/organizations/hooks/useOrganization"
import { useFetchHomes } from "src/data/organizations/queries/homeQueries"
import { DropdownSelect } from "src/ui/DropdownSelect/DropdownSelect"

export function HomesDropdown({
  label,
  selectedHome,
  onSelect,
}: {
  label: string
  selectedHome: THome | null
  onSelect: (home: THome) => void
}) {
  const { org } = useOrganization()

  const [search, setSearch] = useState("")

  const fetchHomes = useFetchHomes({
    orgId: org.id,
    filters: { name: search },
  })

  const options = useMemo(() => {
    if (!fetchHomes.data) {
      return []
    }

    return fetchHomes.data?.homes.map((home) => ({
      label: home.name || home.home_id,
      value: home.home_id,
      home,
    }))
  }, [fetchHomes.data])

  return (
    <DropdownSelect<string, { home: THome }>
      label={label}
      options={options}
      selectedValue={selectedHome?.home_id ?? null}
      onChange={({ option }) => {
        onSelect(option.home)
      }}
      searchText={search}
      onSearch={setSearch}
      fullWidth
    />
  )
}
